import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { Sigla } from 'shell/models/sigla';

interface SiglaSelectProps {
  value?: string;
  onChange: (item: string) => void;
  error?: boolean;
  label?: string;
  required?: boolean;
}

const SiglaSelectComponent = ({
  value,
  onChange,
  label = 'Sigla',
  error,
  required,
}: SiglaSelectProps): React.ReactElement => {
  const [listaSigle] = useHttpFetch<HttpResponseList<Sigla>, Array<ItemVM>>(
    `${__CIVIL_STATUS_API_URL__}/certificato-internazionale/sigle-enunciazioni`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response: AxiosResponse<HttpResponseList<Sigla>>) => {
        const { data } = response;
        return data?.payload?.list?.map((item) => ({
          id: item.modelDecCertInt.sigla || '',
          value: item.modelDecCertInt.descrizione || '',
        }));
      },
    }
  );

  const stampsList = (listaSigle.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id={`id-select-Sigla`}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={`label-select-Sigla`}
        id={`id-select-Sigla`}
        name={`id-select-Sigla`}
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) => onChange(event?.target.value)}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {stampsList.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

SiglaSelectComponent.displayName = 'Sigla Select';

const SiglaSelect = memo(SiglaSelectComponent);

export default SiglaSelect;
